module.exports = __webpack_public_path__ + "img/avia-sale_f3d904f.webp";